<template>
  <b-container class="pt-4">
    <div v-if="loading" id="loading" class="text-center">
      <loading :message="'Loading...'"></loading>
    </div>
    <section v-if="!loading && !showManageRequest">
      <setup-request
        :show-manage-request.sync="showManageRequest"
        :site-id.sync="siteId"
        :study-id.sync="studyId"
        :study-options="studyOptions"
        :studySites="studySites"
        @switchToManageRequest="showManageRequest = $event"
      />
    </section>
    <section v-if="showManageRequest">
      <manage-request
        :siteId="siteId"
        :studyId="studyId"
        @hideManageRequest="showManageRequest = false"
      ></manage-request>
    </section>
    <b-modal
      id="no-study-site-modal"
      centered
      header-bg-variant="warning"
      header-class="justify-content-center"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      ok-only
      title="Warning"
    >
      <h5 class="my-4 text-center">
        <strong
          >This study-site ({{ $route.params.studyId + '-' + $route.params.siteId }}) combination
          does not exist.</strong
        >
      </h5>
      <b-button block class="mt-3" @click="$bvModal.hide('no-study-site-modal')"
        >Manually select a study-site
      </b-button>
    </b-modal>
  </b-container>
</template>

<script>
  import ManageRequest from '../ManageRequest';
  import SetupRequest from './SetupRequest';

  export default {
    components: {
      SetupRequest,
      ManageRequest,
    },
    data() {
      return {
        siteId: null,
        studyId: null,
        studyOptions: [],
        loading: false,
        showManageRequest: false,
        studySites: [],
      };
    },
    created() {
      this.getSitesStudies();
      this.$store.commit('setUserDetails', {});
    },
    methods: {
      async getSitesStudies() {
        try {
          this.loading = true;
          let params = {
            current_status: 'ONGOING,PROPOSED,PLANNED',
            compact: 1,
            include_sites: 1,
            exclude_studies_without_sites: 1,
          };
          let response = await axios.get(`/api/get-studies`, { params: params });
          if (response.status === 204) {
            this.loading = false;
          } else {
            this.studySites = response.data.items;
            this.studyOptions = this.studySites.map(element => {
              return element['studyId'];
            });
            this.studyOptions.sort((a, b) => a.localeCompare(b));
          }
        } catch (error) {
          console.error(error);
          alert(`Server is not responding, please try again later`);
        }
        this.loading = false;
      },
    },
  };
</script>
